import service from './axios';

// 获取微信配置
export const getWechatSettings = () => {
  return service({
    url: '/manage/settings',
    method: 'get',
  });
};

// 保存微信配置
export const saveWechatSettings = (settings) => {
  return service({
    url: '/manage/settings/batch',
    method: 'post',
    data: { settings },
  });
};
